import { NotificationsWidget } from '@/components/modules/Notifications/components/NotificationsWidget/NotificationsWidget';
import { AgentDetailActions } from '@/components/widgets/AgentDetailActions/AgentDetailActions';
import { AgentPageTitle } from '@/components/widgets/AgentPageTitle';
import { ApplicationPageTitle } from '@/components/widgets/ApplicationPageTitle';
import { ChannelDetailActions } from '@/components/widgets/ChannelDetailActions/ChannelDetailActions';
import { ChannelPageTitle } from '@/components/widgets/ChannelPageTitle';
import { CheckoutSessionPageTitle } from '@/components/widgets/CheckoutSessionPageTitle';
import { CreditCardPageManager } from '@/components/widgets/CreditCardPageManager';
import { CustomerSupport } from '@/components/widgets/CustomerSupport/CustomerSupport';
import { HomePageTitle } from '@/components/widgets/HomePageTitle';
import { LoanDetailActions } from '@/components/widgets/LoanDetailActions/LoanDetailActions';
import { LoanHighlights } from '@/components/widgets/LoanHighlights';
import { LoanPageManager } from '@/components/widgets/LoanPageManager';
import { LoanProductTypeRedirect } from '@/components/widgets/LoanProductTypeRedirect';
import { LoanSourceWidget } from '@/components/widgets/LoanSourceWidget';
import { MerchantDetailActions } from '@/components/widgets/MerchantDetailActions/MerchantDetailActions';
import { MerchantListActions } from '@/components/widgets/MerchantListActions/MerchantListActions';
import { MerchantPageTitle } from '@/components/widgets/MerchantPageTitle';
import { OpenApplication } from '@/components/widgets/OpenApplication';
import { CreditCardParticipantSourceWidget } from '@/components/widgets/ParticipantSourceWidget/CreditCardParticipantSourceWidget/CreditCardParticipantSourceWidget';
import { LoanParticipantSourceWidget } from '@/components/widgets/ParticipantSourceWidget/LoanParticipantSourceWidget/LoanParticipantSourceWidget';
import { PayoutPageTitle } from '@/components/widgets/PayoutPageTitle';

export const WIDGETS = {
  LOAN_PARTICIPANT_SOURCE_WIDGET: <LoanParticipantSourceWidget />,
  CREDIT_CARD_PARTICIPANT_SOURCE_WIDGET: <CreditCardParticipantSourceWidget />,
  LOAN_SOURCE_WIDGET: <LoanSourceWidget />,
  LOAN_HIGHLIGHTS: <LoanHighlights />,
  MERCHANT_PAGE_TITLE: <MerchantPageTitle />,
  AGENT_PAGE_TITLE: <AgentPageTitle />,
  CHANNEL_PAGE_TITLE: <ChannelPageTitle />,
  LOAN_PAGE_TITLE: <LoanPageManager />,
  CREDIT_CARD_PAGE_TITLE: <CreditCardPageManager />,
  CHECKOUT_SESSION_PAGE_TITLE: <CheckoutSessionPageTitle />,
  LOAN_PRODUCT_TYPE_REDIRECT: <LoanProductTypeRedirect />,
  MERCHANT_LIST_ACTIONS_WIDGET: <MerchantListActions />,
  MERCHANT_DETAIL_ACTIONS_WIDGET: <MerchantDetailActions />,
  LOAN_DETAIL_ACTIONS: <LoanDetailActions />,
  AGENT_DETAIL_ACTIONS_WIDGET: <AgentDetailActions />,
  CHANNEL_DETAILS_ACTIONS_WIDGET: <ChannelDetailActions />,
  OPEN_APPLICATION: <OpenApplication />,
  PAYOUT_PAGE_TITLE: <PayoutPageTitle />,
  CUSTOMER_SUPPORT: <CustomerSupport />,
  NOTIFICATIONS_WIDGET: <NotificationsWidget />,
  HOME_PAGE_TITLE: <HomePageTitle />,
  APPLICATION_PAGE_TITLE: <ApplicationPageTitle />,
  DUMMY_WIDGET: <> </>,
};
